/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_GenericInputs */

const en_portal_x13_error_generic = /** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sign-in did not finish. Use the email link instead.`)
};

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const ar_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const he_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const ur_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const es_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const fr_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const de_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const pt_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const hi_portal_x13_error_generic = en_portal_x13_error_generic;

/** @type {(inputs: Portal_X13_Error_GenericInputs) => LocalizedString} */
const bn_portal_x13_error_generic = en_portal_x13_error_generic;

/**
* | output |
* | --- |
* | "The sign-in did not finish. Use the email link instead." |
*
* @param {Portal_X13_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_generic = /** @type {((inputs?: Portal_X13_Error_GenericInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_GenericInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_error_generic(inputs)
	if (locale === "he") return he_portal_x13_error_generic(inputs)
	if (locale === "ur") return ur_portal_x13_error_generic(inputs)
	if (locale === "es") return es_portal_x13_error_generic(inputs)
	if (locale === "fr") return fr_portal_x13_error_generic(inputs)
	if (locale === "de") return de_portal_x13_error_generic(inputs)
	if (locale === "pt") return pt_portal_x13_error_generic(inputs)
	if (locale === "hi") return hi_portal_x13_error_generic(inputs)
	if (locale === "bn") return bn_portal_x13_error_generic(inputs)
	return /** @type {LocalizedString} */ ("The sign-in did not finish. Use the email link instead.")
});